import React from 'react';
import Text from '../text/text';

type Props = {
  refetch: () => void;
};

export default function GeneralErrorState({ refetch }: Props) {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100 my-2">
      <Text variant="h2" align="center">
        Something went wrong.
      </Text>
      <Text className="mt-1" align="center">
        Please try again or if this problem persists, contact us at{' '}
        <a href="mailto:support@gosearch.ai">support@gosearch.ai</a>.
      </Text>
      <button className="btn btn-primary mt-1" type="button" onClick={refetch}>
        Try again
      </button>
    </div>
  );
}
